import { _ } from "i18n";
import { PlayerStatType } from "../PlayerStats/definition";

export interface SelectOption {
	value: string;
	label: string;
	flag?: string;
	condition?: (eventType: PlayerStatType) => boolean;
	isDisabled?: boolean;
}

interface FilterConfig {
	filter_key?: string;
	label: string;
	placeholder: string;
	options: SelectOption[];
	key: string; // Events key
}

export const EVENT_PARAMETER_OPTIONS: Record<string, FilterConfig[]> = {
	takeOn: [
		{
			key: "success",
			label: "event.v3.flag.success",
			placeholder: "event.v3.flag.success",
			options: [
				{ value: "true", label: "event.v3.flag.success.true", flag: "take_on" },
				{
					value: "false",
					label: "event.v3.flag.success.false",
					flag: "take_on",
				},
			],
		},
	],
	// Note: will be added in next release
	// foulWon: [
	// 	{
	// 		key: "underPressure",
	// 		label: "event.v3.label.flag",
	// 		placeholder: "event.v3.label.flag",
	// 		options: [{ value: "true", label: "event.v3.flag.under_pressure" }],
	// 	},
	// ],
	shot: [
		{
			key: "flag",
			label: "event.v3.flag.body_part",
			placeholder: "event.v3.flag.body_part",
			options: [
				{
					value: "head",
					label: "event.v3.flag.body_part.head",
					flag: "body_part",
				},
				{
					value: "left-foot",
					label: "event.v3.flag.body_part.left_foot",
					flag: "body_part",
				},
				{
					value: "right-foot",
					label: "event.v3.flag.body_part.right_foot",
					flag: "body_part",
				},
			],
			filter_key: "event.offensive.shot.body_part",
		},
		// Note: will be added in next release
		// {
		// 	key: "underPressure",
		// 	label: "event.v3.label.flag",
		// 	placeholder: "event.v3.label.flag",
		// 	options: [{ value: "true", label: "event.v3.flag.under_pressure" }],
		// },
	],
	aerialDuel: [
		{
			key: "success",
			label: "event.v3.flag.success",
			placeholder: "event.v3.flag.success",
			options: [
				{
					value: "true",
					label: "event.v3.flag.success.true",
					flag: "aerial_duel",
				},
				{
					value: "false",
					label: "event.v3.flag.success.false",
					flag: "aerial_duel",
				},
			],
		},
	],
	pass: [
		{
			key: "success",
			label: "event.v3.flag.success",
			placeholder: "event.v3.flag.success",
			options: [
				{ value: "true", label: "event.v3.flag.success.true", flag: "pass" },
				{ value: "false", label: "event.v3.flag.success.false", flag: "pass" },
			],
		},
		{
			key: "flag",
			label: "event.v3.flag.body_part",
			placeholder: "event.v3.flag.body_part",
			options: [
				{
					value: "head",
					label: "event.v3.flag.body_part.head",
					flag: "body_part",
				},
				{
					value: "left-foot",
					label: "event.v3.flag.body_part.left_foot",
					flag: "body_part",
				},
				{
					value: "right-foot",
					label: "event.v3.flag.body_part.right_foot",
					flag: "body_part",
				},
			],
			filter_key: "event.distribution.pass.body_part",
		},
		// Note: will be added in next release
		// {
		// 	key: "underPressure",
		// 	label: "event.v3.label.flag",
		// 	placeholder: "event.v3.label.flag",
		// 	options: [{ value: "true", label: "event.v3.flag.under_pressure" }],
		// },
	],
	// Note: will be added in next release
	// passReceived: [
	// 	{
	// 		key: "underPressure",
	// 		label: "event.v3.label.flag",
	// 		placeholder: "event.v3.label.flag",
	// 		options: [{ value: "true", label: "event.v3.flag.under_pressure" }],
	// 	},
	// ],
	card: [
		{
			key: "flag",
			label: "event.v3.flag.card_type",
			placeholder: "event.v3.flag.card_type",
			options: [
				{
					value: "yellow",
					flag: "card_type",
					label: "event.v3.flag.card_type.yellow",
				},
				{
					value: "red",
					flag: "card_type",
					label: "event.v3.flag.card_type.red",
				},
			],
		},
	],
	// Note: will be added in next release
	// foulCommitted: [
	// 	{
	// 		key: "underPressure",
	// 		label: "event.v3.label.flag",
	// 		placeholder: "event.v3.label.flag",
	// 		options: [{ value: "true", label: "event.v3.flag.under_pressure" }],
	// 	},
	// ],
	// interception: [
	// 	{
	// 		key: "underPressure",
	// 		label: "event.v3.label.flag",
	// 		placeholder: "event.v3.label.flag",
	// 		options: [{ value: "true", label: "event.v3.flag.under_pressure" }],
	// 	},
	// ],
	tackle: [
		{
			key: "success",
			label: "event.v3.flag.success",
			placeholder: "event.v3.flag.success",
			options: [
				{ value: "true", label: "event.v3.flag.success.true", flag: "tackle" },
				{
					value: "false",
					label: "event.v3.flag.success.false",
					flag: "tackle",
				},
			],
		},
	],
	save: [
		{
			key: "flag",
			label: "event.v3.flag.body_part",
			placeholder: "event.v3.flag.body_part",
			options: [
				{
					value: "head",
					label: "event.v3.flag.body_part.head",
					flag: "body_part",
				},
				{
					value: "left-foot",
					label: "event.v3.flag.body_part.left_foot",
					flag: "body_part",
				},
				{
					value: "right-foot",
					label: "event.v3.flag.body_part.right_foot",
					flag: "body_part",
				},
			],
			filter_key: "event.goalkeeper.save.body_part",
		},
	],
};
